var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_container"},[_c('MHeader'),_c('router-view'),_c('MFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }